import {AfterViewInit, Component, HostListener, OnInit, ViewChild} from '@angular/core';
import {BreakpointObserver, BreakpointState} from '@angular/cdk/layout';
import {MatSidenav} from '@angular/material/sidenav';
import {AppService} from 'src/app/app.service';

declare var $: any;

@Component({
  selector: 'fx-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.sass'],
})
export class LayoutComponent implements OnInit, AfterViewInit {
  @ViewChild('drawer', { static: false }) drawer: MatSidenav;
  menuStyle: string;
  matOpened = true;
  firstTime = true;
  currentScrollPos = 0;
  @HostListener('window:scroll', ['$event']) public onScroll(
    $event: Event
  ): void {
    // tslint:disable-next-line:no-string-literal
    this.currentScrollPos = $event.srcElement['scrollingElement'].scrollTop;
    if (this.currentScrollPos < window.outerHeight)
      this.setPositionTopmenu();
  }
  constructor(
    private breakpointObserver: BreakpointObserver,
    private appService: AppService,
  ) {}

  ngOnInit() {
    this.breakpointObserver
      .observe(['(max-width: 767px)'])
      .subscribe((state: BreakpointState) => {
        if (state.matches) {
          this.menuStyle = 'full';
        } else {
          this.menuStyle = 'side';
        }
      });
  }

  ngAfterViewInit() {
    if (this.menuStyle === 'full') {
      this.onDrawerClick();
    }
  }

  onDrawerClick(data?: any) {
    if ($('.body').hasClass('collapsed')) {
      $('.body').removeClass('collapsed');
      $('.aside').css('left', '-9999px');
    } else {
      if (data === 'body') {
        return;
      }
      $('.body').addClass('collapsed');
      $('.aside').css('left', '0');
      this.setPositionTopmenu();
    }
  }

  setPositionTopmenu(): void {
    $('.aside').css('top',this.currentScrollPos);
  }

  onNavClick(menuItem: any) {
    if (this.menuStyle === 'full') {
      this.onDrawerClick();
    }
  }
}
